export const DEFAULT_PAYMENT_TTL_MINUTES = 15;

/** Effective online payment window: valid org setting or safe default. */
export function normalizePaymentTTLMinutes(value: unknown): number {
  return typeof value === 'number' && Number.isInteger(value) && value >= 1 && value <= 1440
    ? value
    : DEFAULT_PAYMENT_TTL_MINUTES;
}

export function resolvePaymentTTLMinutes(
  widgetConfig?: { payment_ttl_minutes?: number } | null,
  guestShowcaseOrg?: { payment_ttl_minutes?: number } | null
): number {
  const isValid = (v: unknown): v is number =>
    typeof v === 'number' && Number.isInteger(v) && v >= 1 && v <= 1440;
  const widgetTTL = widgetConfig?.payment_ttl_minutes;
  if (isValid(widgetTTL)) return widgetTTL;
  const guestTTL = guestShowcaseOrg?.payment_ttl_minutes;
  if (isValid(guestTTL)) return guestTTL;
  return DEFAULT_PAYMENT_TTL_MINUTES;
}

function pluralRu(n: number, one: string, few: string, many: string): string {
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 14) return many;
  const mod10 = n % 10;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
}

/** "в течение 15 минут", "в течение 1/21 минуты", "в течение 2/22 минут". */
export function formatPaymentTTLMinutes(minutes: number): string {
  const n = normalizePaymentTTLMinutes(minutes);
  if (n % 60 === 0) {
    const hours = n / 60;
    return `${hours} ${pluralRu(hours, 'часа', 'часа', 'часов')}`;
  }
  return `${n} ${pluralRu(n, 'минуты', 'минут', 'минут')}`;
}

/** "за 15 минут", "за 1/21 минуту", "за 2/22 минуты", "за 1/21 час". */
export function formatCancellationLeadMinutes(minutes: number): string {
  const n = Math.max(0, Math.floor(minutes));
  if (n >= 60 && n % 60 === 0) {
    const hours = n / 60;
    return `${hours} ${pluralRu(hours, 'час', 'часа', 'часов')}`;
  }
  return `${n} ${pluralRu(n, 'минуту', 'минуты', 'минут')}`;
}
